import { BookOpenIcon } from 'lucide-react';
import Image from 'next/image';
import { useState } from 'react';

interface FaviconImageProps {
  src: string;
}

export const FaviconImage = ({ src }: FaviconImageProps) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return <BookOpenIcon className="mt-0.5 size-4 shrink-0 text-text-secondary" />;
  }

  return (
    <Image
      src={src}
      alt=""
      width={16}
      height={16}
      unoptimized
      className="mt-0.5 size-4 shrink-0 rounded-sm"
      onError={() => setHasError(true)}
    />
  );
};
